import { createFileRoute } from "@tanstack/react-router";
import CustomerService from "@/pages/customer/CustomerService";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/my-account/service")({
  head: () => { const h = pageHead({ title: 'Rex & Sons RVs', description: 'Rex & Sons RVs — family-owned RV dealer in Castle Hayne, NC since 1997. Sales, service, parts and rentals.', path: '/my-account/service' }); h.meta.push({ name: "robots", content: "noindex, follow" }); return h; },
  component: CustomerService,
});
